var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#D42216"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 10.74C17.62 11.22 17.52 11.6933 17.32 12.16C17.12 12.6133 16.86 13.06 16.54 13.5C16.2333 13.9267 15.88 14.3467 15.48 14.76C15.08 15.16 14.68 15.5533 14.28 15.94C14.0667 16.14 13.8267 16.38 13.56 16.66C13.2933 16.94 13.04 17.22 12.8 17.5C12.56 17.78 12.3533 18.0533 12.18 18.32C12.0067 18.5733 11.9133 18.7867 11.9 18.96H18.06V21H9.24C9.22667 20.8933 9.22 20.7667 9.22 20.62C9.22 20.46 9.22 20.34 9.22 20.26C9.22 19.62 9.32 19.0333 9.52 18.5C9.73333 17.9533 10.0067 17.4467 10.34 16.98C10.6733 16.5133 11.0467 16.0733 11.46 15.66C11.8733 15.2467 12.2867 14.84 12.7 14.44C13.02 14.1333 13.3267 13.8333 13.62 13.54C13.9133 13.2467 14.1667 12.96 14.38 12.68C14.6067 12.3867 14.7867 12.0933 14.92 11.8C15.0533 11.4933 15.12 11.18 15.12 10.86C15.12 10.1667 14.92 9.67333 14.52 9.38C14.12 9.08667 13.6333 8.94 13.06 8.94C12.6867 8.94 12.34 8.99333 12.02 9.1C11.7 9.20667 11.4133 9.33333 11.16 9.48C10.92 9.62667 10.7067 9.78 10.52 9.94C10.3333 10.0867 10.1933 10.2067 10.1 10.3L8.9 8.6C9.46 8.06667 10.1133 7.64 10.86 7.32C11.62 6.98667 12.4333 6.82 13.3 6.82C14.78 6.82 15.8667 7.17333 16.56 7.88C17.2667 8.57333 17.62 9.52667 17.62 10.74Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/Number2.0973b584c48aa1a94aa228efb4915118.svg";
export { ForwardRef as ReactComponent };